import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import defaultSetting from '@/settings'
import ErrorList from '@/ErrorList'
import cache from "@/plugin/cache";

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API + "/" + defaultSetting.api_version, // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers['Authorization'] = store.getters.token_type + " " + getToken()
        }
        // 是否需要防止数据重复提交
        const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
        if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
            const requestObj = {
                url: config.url,
                data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
                time: new Date().getTime()
            }
            const sessionObj = cache.session.getJSON('sessionObj')
            if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
                cache.session.setJSON('sessionObj', requestObj)
            } else {
                const s_url = sessionObj.url;                  // 请求地址
                const s_data = sessionObj.data;                // 请求数据
                const s_time = sessionObj.time;                // 请求时间
                const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
                if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                    const message = '数据正在处理，请勿重复提交';
                    console.warn(`[${s_url}]: ` + message)
                    return Promise.reject(new Error(message))
                } else {
                    cache.session.setJSON('sessionObj', requestObj)
                }
            }
        }

        return config
    },
    error => {
        // do something with request error
        console.log(error);
        return Promise.reject(error);
    }
);

//特殊处理器
const err_process = {
    relogin(err_obj) {
        MessageBox.confirm(err_obj.message, "提示", {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: err_obj.type
        }).then(() => {
            store.dispatch('user/resetToken').then(() => {
                location.reload();
            });
        });
    }
};

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code !== 200) {
            //查找错误代码
            let err_obj = null;
            if (typeof ErrorList[res.code] !== "undefined") {
                err_obj = ErrorList[res.code];
            } else {
                err_obj = ErrorList["other"];
            }
            if (err_obj.do) {
                //特殊处理
                err_process.relogin(err_obj);
            } else {
                Message({
                    message: typeof res.msg == "string" ? res.msg : err_obj.message,
                    type: err_obj.type,
                    duration: 5000
                });
            }
            return Promise.reject(res);
        } else {
            return res;
        }
    },
    error => {
        //如500错误 504等...
        console.log('request error:', error);
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error)
    }
);

window.axios = service;

export default service
